import React from "react";
import Image from "next/image";
import Link from "next/link";

const HealthcareDeskBanner: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = 0;
    if (window.innerWidth <= 768) {
      yOffset = -100;
    } else {
      yOffset = -150;
    }

    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="mx-auto w-full 2xl:h-[700px] md:h-[600px] h-[95vh] xl:px-0 md:px-6 lg:!px-6 px-0 relative md:bg-bottom bg-center square_grid_bg bg-repeat bg-[length:100% 100%] md:pb-0 pb-[00px]">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-[0] relative md:block hidden">
          <div className="flex justify-between flex-wrap">
            <div className="md:pt-5 pt-5 pb-7 2xl:w-[66%] xl:w-[64%] lg:w-[64%] md:w-[64%] w-full md:pb-16 relative md:top-[135px]">
              <div className="md:text-left text-left">
                <h1 className="2xl:text-[56px] xl:text-[50px] md:text-[38px] text-[28px] font-bold leading-[1.1] text-[#030F1C] inline-block relative">
                  <span>Addressing the</span>
                  <Image
                    priority
                    src="/healthcare/str.png"
                    alt="healthcare icon"
                    className="absolute -top-8 -left-6"
                    width={35}
                    height={45}
                    quality={100}
                  />
                </h1>
                <p className="text-[#030F1C] 2xl:text-[72px] lg:text-[58px] leading-[1.1] md:text-[22px] text-[28px] font-bold md:mt-2">
                  <span className="text-[#008D82] font-bold">Healthcare</span>{" "}
                  Talent
                  <br /> Shortage{" "}
                  <span className="2xl:text-[56px] md:text-[38px] font-bold">
                    in the US
                  </span>
                </p>

                <div className="flex justify-start gap-5 mt-7">
                  <Link
                    href={"/us-jobs-for-nurses"}
                    className="hel_btn_sha flex gap-3 items-center border-[2px] border-[#FFA548] rounded-[14px] bg-white px-6 py-2 font-semibold 2xl:text-[22px] xl:text-[20px] md:text-[16px] hover:border-blue-500 transition-colors"
                  >
                    Nurses
                  </Link>

                  <Link
                    href={"/mbbs"}
                    className="hel_btn_sha flex gap-3 items-center border-[2px] border-[#FFA548] rounded-[10px] bg-white px-6 py-2 font-semibold 2xl:text-[22px] xl:text-[20px] md:text-[16px] hover:border-blue-500 transition-colors"
                  >
                    Doctors
                  </Link>
                </div>
                <div className="md:text-left text-center md:mt-[30px] mt-[20px] mb-[15px]">
                  <div
                    className="grp_btn flex md:justify-left justify-center items-center w-[238px] cursor-pointer"
                    onClick={() => scrollToSection("dream")}
                  >
                    <Image
                      priority
                      src="/arrow2.png"
                      alt="arrow image"
                      className="new_arrow "
                      width={39}
                      height={49}
                    />
                    <p
                      className="healthcare_btn inline-block !px-[20px] !py-[10px] md:text-[18px] 2xl:text-[18px] font-medium"
                      onClick={() => scrollToSection("leverage")}
                    >
                      Discover Programs
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg_desktop">
            <Image
              src="/healthcare/healthBan-desk.png"
              alt="Healthcare Shortage in USA"
              className="absolute top-0 bottom-0 right-0 h-[700px]"
              width={720}
              height={580}
            />
          </div>
        </div>
        <div className="md_desktop">
          <Image
            src="/healthcare/healthBan-desk.png"
            alt="Healthcare Shortage in USA"
            className="absolute top-0 bottom-0 right-0 md:block hidden w-[810px] md:h-[600px] lg:h-[700px]"
            width={720}
            height={580}
          />
        </div>
        <Image
          src="/healthcare/helt_ban_desk.webp"
          alt="Healthcare Shortage in USA"
          className="absolute top-0 bottom-0 right-0 md:hidden hidden w-[220px]"
          width={400}
          height={300}
        />
      </div>
      <div className="md:block hidden bg-[#061A2F] w-full md:py-12 py-10 z-20">
        <div className="lg:container mx-auto">
          <div className="flex md:justify-between md:flex-nowrap flex-wrap md:px-14">
            <div className="md:w-[30%] w-[100%] text-center">
              <p className="md:text-[42px] text-3xl font-medium text-white">
                70K+
              </p>
              <p className="md:text-[21px] text-[16px] leading-[1.2] font-medium text-[#DCDCDC] md:mt-3 mt-1">
                Global Alumni
                <br />
                Base
              </p>
            </div>

            <div className="md:w-[30%] w-[100%] text-center md:mt-0 mt-5">
              <p className="md:text-[42px] text-3xl font-medium text-white">
                300+
              </p>
              <p className="md:text-[21px] text-[16px] leading-[1.2] font-medium text-[#DCDCDC] md:mt-3 mt-1">
                MNC’c & Corporate
                <br /> Partnerships
              </p>
            </div>

            <div className="md:w-[30%] w-[100%] text-center md:mt-0 mt-5">
              <p className="md:text-[42px] text-3xl font-medium text-white">
                100K+
              </p>
              <p className="md:text-[21px] text-[16px] leading-[1.2] font-medium text-[#DCDCDC] md:mt-3 mt-1">
                University Tie-
                <br />
                ups
              </p>
            </div>
            <div className="md:w-[30%] w-[100%] text-center md:mt-0 mt-5">
              <p className="md:text-[42px] text-3xl font-medium text-white">
                50K+
              </p>
              <p className="md:text-[21px] text-[16px] leading-[1.2] font-medium text-[#DCDCDC] md:mt-3 mt-1">
                Global Training
                <br />
                Centers
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HealthcareDeskBanner;
